import { APITypesV1 } from "@cur8/api-client";
import { useQuery } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";
import { QueryOptions } from "typings/query";
import { applySignal } from "./applySignal";

type Body = APITypesV1.BloodSamplesResponse;
type Key = ["visitBloodSamples", string, string];

export function useVisitBloodSamplesQuery<T = Body>({
  patientId,
  visitId,
  options = {},
}: {
  patientId: string;
  visitId: string;
  options?: QueryOptions<Body, Key, T>;
}) {
  const api = useAPIClient();
  return useQuery({
    queryKey: queryKey(patientId, visitId),
    queryFn: queryFn(api, { patientId, visitId }),
    ...options,
  });
}

const queryKey = (patientId: string, visitId: string): Key => [
  "visitBloodSamples",
  patientId,
  visitId,
];

const queryFn =
  (
    api: ReturnType<typeof useAPIClient>,
    pointer: { patientId: string; visitId: string }
  ) =>
  ({ signal }: { signal: AbortSignal }) => {
    const req = api.bloodSample.getBloodSamplesFor(pointer);
    applySignal(req, signal);

    return req.result;
  };
